import React, { useState } from "react";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";

import {
  Grid2,
  Stack,
  Checkbox,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {
  LoadingMore,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
  NewAssignmentPopup,
} from "components";

import graph from "../graph";
import Model from "./Model";
import Filter from "./Filter";
import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";

export default function List({
  page,
  limit,
  total,
  setPage,

  result,
  refetch,
  loading,

  title,
  isPopup,
  onClose,

  isAssign,
  onAssign,
  assigning,
  multiSelect,

  selectable,
  setSelectable,

  filter,
  setFilter,
  clearFilter,
  preSelected,
}) {
  const [selected, setSelected] = useState(preSelected || []);
  const { roles } = useSelector((state) => state.auth.userInfo);
  const isAdmin = hasRequiredRole(["superadmin"], roles);

  const handleSelect = (item) => {
    const selectedIndex = selected.map((item) => item.id).indexOf(item.id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    if (isAssign && !multiSelect && newSelected.length > 0) {
      onAssign([newSelected.reverse()[0]], onClose);
      setSelected([newSelected.reverse()[0]]);
      return;
    }
    return setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(result);
      return;
    }
    setSelected([]);
  };

  const clearSelection = () => setSelected([]);

  const handleSelectable = () =>
    setSelectable((prev) => {
      if (prev) {
        clearSelection();
      }
      return !prev;
    });

  const refresh = () => {
    clearSelection();
    refetch();
  };

  const acception = result.length;
  const selection = selected.length;

  return (
    <>
      <NewDialogTitle title={title} onClose={onClose} isPopup={isPopup} />
      <NewDialogContent isPopup={isPopup}>
        <Stack px={1} flex={2} overflow="scroll" position="relative">
          <Filter
            init={filter}
            setFilter={setFilter}
            clearFilter={clearFilter}
          />
          <Grid2 alignItems="flex-start" container>
            {result.map((model, i) => (
              <Grid2
                key={i}
                p={0.5}
                size={{ xs: 12, sm: !isPopup && 6, md: !isPopup && 4 }}
              >
                <Model
                  model={model}
                  refetch={refetch}
                  isAssign={isAssign}
                  delay={(i % limit) + 1}
                  checked={
                    selected.find((select) => model.id === select.id)
                      ? true
                      : false
                  }
                  handleSelect={() =>
                    handleSelect({ id: model?.id, title: model.title })
                  }
                />
              </Grid2>
            ))}
            <Grid2 p={0.5} size={{ xs: 12 }}>
              <LoadingMore
                total={total}
                loading={loading}
                result={result.length}
                onClick={() => setPage(page + 1)}
              />
            </Grid2>
          </Grid2>
        </Stack>
        {isAssign && multiSelect && (
          <NewAssignmentPopup
            graph={graph}
            title={title}
            onClose={onClose}
            onAssign={onAssign}
            selected={selected}
            assigning={assigning}
            handleSelect={handleSelect}
          />
        )}
      </NewDialogContent>
      <NewDialogActions isPopup={isPopup}>
        <Stack
          width="100%"
          alignItems="center"
          direction="row-reverse"
          justifyContent="space-between"
        >
          <Stack
            columnGap={0.5}
            alignItems="center"
            direction="row-reverse"
            justifyContent="space-between"
          >
            {loading ? (
              <CircularProgress color="primary" size={36} />
            ) : (
              <IconButton
                size="medium"
                color="default"
                onClick={refresh}
                sx={{ bgcolor: "action.hover" }}
              >
                <RefreshRoundedIcon color="inherit" fontSize="small" />
              </IconButton>
            )}
          </Stack>
          {!isAssign && (
            <Stack
              borderRadius={2}
              direction="row"
              alignItems="center"
              bgcolor="action.hover"
            >
              {selectable && (
                <Checkbox
                  size="small"
                  color="warning"
                  onChange={handleSelectAllClick}
                  checked={acception > 0 && selection === acception}
                  indeterminate={selection > 0 && selection < acception}
                />
              )}
              <IconButton onClick={handleSelectable}>
                {selectable ? (
                  <LockRoundedIcon fontSize="small" color="error" />
                ) : (
                  <LockOpenRoundedIcon fontSize="small" color="primary" />
                )}
              </IconButton>
            </Stack>
          )}
        </Stack>
      </NewDialogActions>
    </>
  );
}
